import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import AppRouter from "./app/AppRouter";
import { SiteDataProvider } from "./app/SiteDataContext";
import "./index.css";

function App() {
  return (
    <HelmetProvider>
      <SiteDataProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </SiteDataProvider>
    </HelmetProvider>
  );
}

export default App;
